import {useFormikContext} from 'formik';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {FromikType} from '../../../types';

interface IWaterSystemBottomSheet {
  openWaterSystemBottomSheet: boolean;
  SetOpenWaterSystemBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  waterSystemData: IWaterSystem[] | undefined;
}

function WaterSystemBottomSheet({
  openWaterSystemBottomSheet,
  SetOpenWaterSystemBottomSheet,
  waterSystemData,
}: IWaterSystemBottomSheet) {
  const {setFieldValue} = useFormikContext<FromikType>();

  return (
    <BottomSheet
      onDismiss={() => SetOpenWaterSystemBottomSheet(false)}
      open={openWaterSystemBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col px-3 gap-3 pb-3">
        {waterSystemData?.map(item => (
          <span
            key={item.guid}
            onClick={() => {
              setFieldValue('water_system', {
                name: item?.title,
                guid: item?.guid,
              });
              SetOpenWaterSystemBottomSheet(false);
            }}
          >
            {item.title}
          </span>
        ))}
      </div>
    </BottomSheet>
  );
}

export default WaterSystemBottomSheet;
